module.exports = __webpack_public_path__ + "static/media/testreact_background.4fc6ff1e.png";